import { withPopover } from '@vlabs/monokit/shared/ui/popovers/withPopover';
import { SideMenuFilterItem } from '@vlabs/monokit/shared/ui/side-menu-filter-item';

// eslint-disable-next-line import-x/no-namespace
import * as Popovers from './popovers';

const withLeftPopover = withPopover({ placement: 'left-start' });
const withRightPopover = withPopover({ placement: 'right-start' });

const withSideMenuItemLeftPopover = withLeftPopover(SideMenuFilterItem);
const withSideMenuItemRightPopover = withRightPopover(SideMenuFilterItem);

export const DateFilterWithLeftPopover = withSideMenuItemLeftPopover(Popovers.DateFilterPopover);
export const DateFilterWithRightPopover = withSideMenuItemRightPopover(Popovers.DateFilterPopover);
export const SourceFilterWithLeftPopover = withSideMenuItemLeftPopover(Popovers.SourceFilterPopover);
export const SourceFilterWithRightPopover = withSideMenuItemRightPopover(Popovers.SourceFilterPopover);
export const HandlersFilterWithLeftPopover = withSideMenuItemLeftPopover(Popovers.HandlersFilterPopover);
export const HandlersFilterWithRightPopover = withSideMenuItemRightPopover(Popovers.HandlersFilterPopover);
export const ListsFilterWithLeftPopover = withSideMenuItemLeftPopover(Popovers.ListsFilterPopover);
export const ListsFilterWithRightPopover = withSideMenuItemRightPopover(Popovers.ListsFilterPopover);
export const PermissionTagsFilterWithLeftPopover = withSideMenuItemLeftPopover(
  Popovers.PermissionTagsFilterPopover,
);
export const PermissionTagsFilterWithRightPopover = withSideMenuItemRightPopover(
  Popovers.PermissionTagsFilterPopover,
);
export const EventIdFilterWithLeftPopover = withSideMenuItemLeftPopover(Popovers.EventIdFilterPopover);
export const EventIdFilterWithRightPopover = withSideMenuItemRightPopover(Popovers.EventIdFilterPopover);
export const CardIdFilterWithLeftPopover = withSideMenuItemLeftPopover(Popovers.CardIdFilterPopover);
export const CardIdFilterWithRightPopover = withSideMenuItemRightPopover(Popovers.CardIdFilterPopover);
export const ComparingAttributeFilterWithLeftPopover = withSideMenuItemLeftPopover(
  Popovers.ComparingAttributeFilterPopover,
);
export const ComparingAttributeFilterWithRightPopover = withSideMenuItemRightPopover(
  Popovers.ComparingAttributeFilterPopover,
);
export const SimilarityFilterWithLeftPopover = withSideMenuItemLeftPopover(Popovers.SimilarityFilterPopover);
export const SimilarityFilterWithRightPopover = withSideMenuItemRightPopover(Popovers.SimilarityFilterPopover);
export const TopSimilarObjectsFilterWithLeftPopover = withSideMenuItemLeftPopover(
  Popovers.TopSimilarObjectsFilterPopover,
);
export const TopSimilarObjectsFilterWithRightPopover = withSideMenuItemRightPopover(
  Popovers.TopSimilarObjectsFilterPopover,
);
export const TopSimilarCardIdsFilterWithLeftPopover = withSideMenuItemLeftPopover(
  Popovers.TopSimilarCardIdsFilterPopover,
);
export const TopSimilarCardIdsFilterWithRightPopover = withSideMenuItemRightPopover(
  Popovers.TopSimilarCardIdsFilterPopover,
);
export const GenderFilterWithLeftPopover = withSideMenuItemLeftPopover(Popovers.GenderFilterPopover);
export const GenderFilterWithRightPopover = withSideMenuItemRightPopover(Popovers.GenderFilterPopover);
export const AgeFilterWithLeftPopover = withSideMenuItemLeftPopover(Popovers.AgeFilterPopover);
export const AgeFilterWithRightPopover = withSideMenuItemRightPopover(Popovers.AgeFilterPopover);
export const EmotionsFilterWithLeftPopover = withSideMenuItemLeftPopover(Popovers.EmotionsFilterPopover);
export const EmotionsFilterWithRightPopover = withSideMenuItemRightPopover(Popovers.EmotionsFilterPopover);
export const MaskFilterWithLeftPopover = withSideMenuItemLeftPopover(Popovers.MaskFilterPopover);
export const MaskFilterWithRightPopover = withSideMenuItemRightPopover(Popovers.MaskFilterPopover);
export const LivenessFilterWithLeftPopover = withSideMenuItemLeftPopover(Popovers.LivenessFilterPopover);
export const LivenessFilterWithRightPopover = withSideMenuItemRightPopover(Popovers.LivenessFilterPopover);
export const DeepfakeFilterWithLeftPopover = withSideMenuItemLeftPopover(Popovers.DeepfakeFilterPopover);
export const DeepfakeFilterWithRightPopover = withSideMenuItemRightPopover(Popovers.DeepfakeFilterPopover);
export const FaceIdFilterWithLeftPopover = withSideMenuItemLeftPopover(Popovers.FaceIdFilterPopover);
export const FaceIdFilterWithRightPopover = withSideMenuItemRightPopover(Popovers.FaceIdFilterPopover);
export const ApparentGenderFilterWithLeftPopover = withSideMenuItemLeftPopover(Popovers.ApparentGenderFilterPopover);
export const ApparentGenderFilterWithRightPopover = withSideMenuItemRightPopover(Popovers.ApparentGenderFilterPopover);
export const ApparentAgeFilterWithLeftPopover = withSideMenuItemLeftPopover(
  Popovers.ApparentAgeFilterPopover,
);
export const ApparentAgeFilterWithRightPopover = withSideMenuItemRightPopover(Popovers.ApparentAgeFilterPopover);
export const UpperAttributesFilterWithLeftPopover = withSideMenuItemLeftPopover(
  Popovers.UpperAttributesFilterPopover,
);
export const UpperAttributesFilterWithRightPopover = withSideMenuItemRightPopover(
  Popovers.UpperAttributesFilterPopover,
);
export const LowerAttributesFilterWithLeftPopover = withSideMenuItemLeftPopover(Popovers.LowerAttributesFilterPopover);
export const LowerAttributesFilterWithRightPopover = withSideMenuItemRightPopover(
  Popovers.LowerAttributesFilterPopover,
);
export const ShoesColorFilterWithLeftPopover = withSideMenuItemLeftPopover(Popovers.ShoesColorFilterPopover);
export const ShoesColorFilterWithRightPopover = withSideMenuItemRightPopover(Popovers.ShoesColorFilterPopover);
export const HeadwearFilterWithLeftPopover = withSideMenuItemLeftPopover(Popovers.HeadwearFilterPopover);
export const HeadwearFilterWithRightPopover = withSideMenuItemRightPopover(Popovers.HeadwearFilterPopover);
export const BackpackFilterWithLeftPopover = withSideMenuItemLeftPopover(Popovers.BackpackFilterPopover);
export const BackpackFilterWithRightPopover = withSideMenuItemRightPopover(Popovers.BackpackFilterPopover);
export const LocationFilterWithLeftPopover = withSideMenuItemLeftPopover(Popovers.LocationFilterPopover);
export const LocationFilterWithRightPopover = withSideMenuItemRightPopover(Popovers.LocationFilterPopover);
export const TrackIdFilterWithLeftPopover = withSideMenuItemLeftPopover(Popovers.TrackIdFilterPopover);
export const TrackIdFilterWithRightPopover = withSideMenuItemRightPopover(Popovers.TrackIdFilterPopover);
export const MetaFilterWithLeftPopover = withSideMenuItemLeftPopover(Popovers.MetaFilterPopover);
export const MetaFilterWithRightPopover = withSideMenuItemRightPopover(Popovers.MetaFilterPopover);
